<div class="d-flex justify-content-between">
  <legend class="h3 mb-16px">User Information</legend>
</div>
<app-dp-detail-info>
  <div class="detail-container">
    <div class="row">
      <div class="col-2 detail-label">Username(ID)</div>
      <div class="col-4 detail-value">{{ userDetail?.username }}</div>
    </div>

    <div class="row">
      <div class="col-2 detail-label">First Name</div>
      <div class="col-4 detail-value">{{ userDetail?.firstName }}</div>
      <div class="col-2 detail-label">Last Name</div>
      <div class="col-4 detail-value">{{ userDetail?.lastName }}</div>
    </div>

    <div class="row">
      <div class="col-2 detail-label">Phone Number</div>
      <div class="col-4 detail-value">
        {{ userDetail?.tel | telNoCountry }}
        {{ userDetail?.ext ? "Ext.:".concat(userDetail?.ext) : "" }}
      </div>
      <div class="col-2 detail-label">Status</div>
      <div class="col-4 detail-value">
        <dp-badge
          [color]="color[userDetail?.status?.toLowerCase()]"
          [size]="''"
          [text]="userDetail?.status"
        >
        </dp-badge>
      </div>
    </div>

    <div class="row">
      <div class="col-2 detail-label">User Type</div>
      <div class="col-4 detail-value">
        <dp-badge
          [color]="color[userDetail?.userType?.toLowerCase()]"
          [size]="''"
          [text]="
            userDetail?.userType === 'RA' ? 'Military' : userDetail?.userType
          "
        >
        </dp-badge>
      </div>
      <div class="col-2 detail-label">Organization</div>
      <div class="col-4 detail-value">{{ userDetail?.organizationName }}</div>
    </div>

    <div class="row">
      <div class="col-2 detail-label">Roles</div>
      <div class="col-4 detail-value">{{ roles }}</div>
      <ng-container *ngIf="![companies.SeaIm].includes(this.company)">
        <div class="col-2 detail-label">Employee No</div>
        <div class="col-4 detail-value">
          <div class="col-4 detail-value">{{ userDetail?.employeeNo }}</div>
        </div>
      </ng-container>
    </div>

    <div class="row">
      <div class="col-2 detail-label">Create Date</div>
      <div class="col-4 detail-value">
        {{ userDetail?.auth.createdAt | date: "short" }}
      </div>
      <div class="col-2 detail-label">Last Login</div>
      <div class="col-3 detail-value">
        {{ userDetail?.lastLogin | date: "short" }}
      </div>
      <div class="col-1">
        <button
          (click)="modalOpen()"
          *ngIf="isEditable && !isAdminViewerRole"
          class="btn btn-dark"
          type="button"
        >
          <font-awesome style="color: white">Edit</font-awesome>
        </button>
      </div>
    </div>

    <div class="row"></div>
  </div>
</app-dp-detail-info>

<div
  *ngIf="
    isAdmin ||
    [userType.be, userType.ussi, userType.ra].includes(userDetail?.userType)
  "
  class="d-flex flex-row justify-content-between mb-3"
>
  <ul class="nav nav-pills" id="pills-tab" role="tablist">
    <li
      (click)="showSubItem('LOCATION_ALIAS')"
      *ngIf="
        [userType.be, userType.ussi, userType.ra].includes(userDetail?.userType)
      "
      class="nav-item"
      role="presentation"
    >
      <button
        [ngClass]="{
          'tab-btn-active': view === 'LOCATION_ALIAS',
          'tab-btn-inactive': view === 'ACTIVITY_SUMMARY'
        }"
        id="LocationAliasTab"
        role="tab"
        type="button"
      >
        Location Alias
      </button>
    </li>
    <li
      (click)="showSubItem('ACTIVITY_SUMMARY')"
      *ngIf="isAdmin"
      class="nav-item"
      role="presentation"
    >
      <button
        [ngClass]="{
          'tab-btn-active': view === 'ACTIVITY_SUMMARY',
          'tab-btn-inactive': view === 'LOCATION_ALIAS'
        }"
        id="ActivitySummaryTab"
        role="tab"
        type="button"
      >
        Activity Summary
      </button>
    </li>
  </ul>
</div>

<div *ngIf="view === 'ACTIVITY_SUMMARY' && isAdmin" class="d-list">
  <app-user-activity-summary-section
    [userInfo]="userDetail"
    [isDealer]="false"
  ></app-user-activity-summary-section>
</div>

<!--<div *ngIf="this.userDetail.userType === 'AGENT'" class="d-list">-->
<!--  <div class="page-title-box dealer-list d-flex">-->
<!--    <h3 class="me-auto" id="dealerList">Dealer List</h3>-->
<!--    <button (click)="dealerOpen()" *ngIf="isAdmin" class="btn btn-dark" type="button">-->
<!--      <font-awesome style="color:white">Assign Dealer</font-awesome>-->
<!--    </button>-->
<!--  </div>-->

<!--  <div class="h-100 w-100 d-flex flex-column">-->
<!--    <div class="table-wrapper w-100" style="position: absolute">-->
<!--      <perfect-scrollbar>-->
<!--        <table class="table table-list align-middle table-nowrap w-100">-->
<!--          <thead>-->
<!--          <tr>-->
<!--            <th>No.</th>-->
<!--            <th>Name</th>-->
<!--            <th>BP #</th>-->
<!--            <th>City</th>-->
<!--            <th>State</th>-->
<!--            <th>HQ</th>-->
<!--            <th>Active Tickets</th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody class="assigned-dealers">-->
<!--          <tr *ngFor="let i = index; let dealer of userDetail.dealers">-->
<!--            <td>{{i + 1}}</td>-->
<!--            <td>{{dealer.name}}</td>-->
<!--            <td>{{dealer.bpNo}}</td>-->
<!--            <td>{{dealer.city}}</td>-->
<!--            <td>{{dealer.state}}</td>-->
<!--            <td>{{dealer.hq}}</td>-->
<!--            <td>{{dealer.activeTickets}}</td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->

<!--      </perfect-scrollbar>-->
<!--    </div>-->
<!--    <div *ngIf="this.userDetail.dealers.length === 0" class="align-center">-->
<!--      <font-awesome [icon]="'fa-light fa-file-circle-exclamation'"></font-awesome>-->
<!--      <span class="pl-14px">No assigned dealer</span>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<div
  *ngIf="
    view === 'LOCATION_ALIAS' &&
    [userType.be, userType.ussi, userType.ra].includes(userDetail?.userType)
  "
  class="d-list"
>
  <div class="page-title-box dealer-list d-flex">
    <h3 class="me-auto" id="locationAliasList">Location Alias List</h3>
    <div *ngIf="!isAdminViewerRole">
      <button
        (click)="locationAliasOpen()"
        *ngIf="isAdmin || isUssiAdmin"
        class="btn btn-dark"
        type="button"
      >
        <font-awesome style="color: white">Assign Location Alias</font-awesome>
      </button>
    </div>
  </div>

  <div
    class="h-100 w-100 d-flex flex-column"
    style="min-height: 0; max-height: 450px"
  >
    <div class="table-wrapper w-100" style="position: relative">
      <perfect-scrollbar>
        <table class="table table-list align-middle table-nowrap w-100">
          <thead>
            <tr>
              <th>No.</th>
              <th>Dealer</th>
              <th>Location Alias</th>
              <th>State</th>
              <th>City</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody class="assigned-dealers">
            <tr
              *ngFor="
                let i = index;
                let locationAlias;
                of: userDetail.locationAliases
              "
            >
              <td>{{ i + 1 }}</td>
              <td>{{ locationAlias.dealerName }}</td>
              <td>{{ locationAlias.locationAlias }}</td>
              <td>{{ locationAlias.address.state }}</td>
              <td>{{ locationAlias.address.city }}</td>
              <td>{{ locationAlias.firstName }}</td>
              <td>{{ locationAlias.lastName }}</td>
              <td>{{ locationAlias.email }}</td>
            </tr>
          </tbody>
        </table>
      </perfect-scrollbar>
    </div>
    <div
      *ngIf="this.userDetail.locationAliases.length === 0"
      class="align-center"
    >
      <font-awesome
        [icon]="'fa-light fa-file-circle-exclamation'"
      ></font-awesome>
      <span class="pl-14px">No location alias</span>
    </div>
  </div>
</div>
